import React from "react";
import Tags from "../../../utils/Tags";
import { workHistory } from "../../../Data/Data";

const WorkHistory = () => {
  return (
    <>
      <h2 className="text-lg py-[1.3rem]">Work History</h2>
      <section className="bg-box p-4 space-y-5">
        {workHistory.map((item) => (
          <div
            key={item.id}
            className={`space-y-5 ${
              item.id !== 1 ? "border-t border-darkText pt-4" : ""
            }`}
          >
            <div className="flex items-end gap-7">
              <h1 className="text-lg font-bold">{item.title}</h1>
              <p className="text-[0.8rem] text-darkText flex items-start gap-1">
                {item.duration}
                {item.active && <span className="p-1 bg-skyBlue rounded-lg" />}
              </p>
            </div>
            <p className="text-darkText text-sm font-light">{item.desc}</p>
            <div className="space-y-1 md:w-[80%]">
              {item.responsibilities.map((responsibility, i) => (
                <div key={i} className="flex items-start gap-1 text-darkText">
                  <span className="p-1 bg-skyBlue rounded-lg mt-1" />
                  <p className="text-sm font-light">{responsibility}</p>
                </div>
              ))}
            </div>
            <div className="flex items-center flex-wrap gap-2">
              {item.tags.map((tag, i) => (
                <Tags key={i} tag={tag} />
              ))}
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default WorkHistory;
